import { useEffect, useRef } from 'react';
import { CART_NOTIF } from '../constants';
import { useStore } from '@/redux/store';
import { useHTTPError } from 'br2s-ui-common-utils-02';
import { cartAPI } from '@/services/api/cart/cartCount';

interface ICartCount {
  productCount: number;
  subscriptionCount: number;
}
interface CartLoaderProps {
  setCartCount: (count: ICartCount) => void;
}

const CartTimer = ({ setCartCount }: CartLoaderProps) => {
  const { cartCount } = useStore();
  const { handleHTTPError } = useHTTPError();
  const { auth } = useStore();

  const cartTimer = CART_NOTIF.LOADING_TIMER;
  const cartTimeout = useRef<number | null>(null);

  // istanbul ignore next
  const callCartTimer = () => {
    if (cartTimeout.current) {
      clearTimeout(cartTimeout.current);
    }

    cartTimeout.current = window.setTimeout(() => {
      cartCountAPI();
    }, cartTimer);
  };

  const cartCountAPI = async () => {
    try {
      const response = await cartAPI.cartCount();

      if (response?.status === 200) {
        const totalCartCount = {
          productCount: response?.data.result.productCount || 0,
          subscriptionCount: response?.data.result.subscriptionCount || 0,
        };

        cartCount(totalCartCount);
        setCartCount(totalCartCount);
        callCartTimer();
      }
    } catch (error) {
      // istanbul ignore next
      handleHTTPError(error, {
        errorType: 'none',
      });
    }
  };

  useEffect(() => {
    cartCountAPI();

    return () => {
      clearTimeout(cartTimeout.current as number);
    };
  }, []);

  useEffect(() => {
    cartCountAPI();

    return () => {
      clearTimeout(cartTimeout.current as number);
    };
  }, [auth.authenticated]);

  return null;
};

export default CartTimer;
